<div>
  <h2 class="step-title">You need to select a FACILITY and USER in order to SEND</h2>

  <ng-container [ngSwitch]="currentStep">
    <ng-container *ngSwitchCase="1">
      <div class="selected-facility-wrap">
        <div class="facility-card accent-red">
          <div class="label">Facility</div>
          <div class="name">{{ formatFacilityName(originFacility.name) }}</div>
          <div class="patient-id">
            Patient ID: <span>{{ originFacility.patientId }}</span>
          </div>
        </div>
      </div>

      <p class="section-label">Choose your facility:</p>
      <div class="facility-grid">
        <button
          type="button"
          class="facility-option"
          [class.selected]="selectedFacility?.id === facility.id"
          *ngFor="let facility of facilities"
          (click)="selectFacility(facility)"
        >
          <span class="label">Facility</span>
          <span class="name">{{ formatFacilityName(facility.name) }}</span>
          <span class="patient-id">
            Patient ID: <strong>{{ facility.patientId }}</strong>
          </span>
        </button>
      </div>

      <div class="actions">
        <button type="button" class="ghost" (click)="onReset()">Cancel</button>
        <button type="button" class="primary" [disabled]="!selectedFacility" (click)="nextStep()">Next</button>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="2">
      <div class="facility-pair">
        <div class="facility-card accent-red">
          <div class="label">Facility</div>
          <div class="name">{{ formatFacilityName(originFacility.name) }}</div>
          <div class="patient-id">
            Patient ID: <span>{{ originFacility.patientId }}</span>
          </div>
        </div>

        <div class="arrow-animation">
          <div class="arrow">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>

        <div class="facility-card accent-blue" *ngIf="selectedFacility">
          <div class="label">Facility</div>
          <div class="name">{{ formatFacilityName(selectedFacility.name) }}</div>
          <div class="patient-id">
            Patient ID: <span>{{ selectedFacility.patientId }}</span>
          </div>
        </div>
      </div>

      <p class="section-label">Now choose your FACILITATOR:</p>

      <div class="facilitator-grid">
        <button
          type="button"
          class="facilitator-option"
          [class.selected]="selectedFacilitator?.id === facilitator.id"
          *ngFor="let facilitator of facilitatorOptions"
          (click)="selectFacilitator(facilitator)"
        >
          <span class="name">{{ facilitator.name }}</span>
          <span class="email">{{ facilitator.email }}</span>
        </button>
        <div class="empty-state" *ngIf="facilitatorOptions.length === 0">
          No facilitators configured for this facility (mock data).
        </div>
      </div>

      <div class="actions">
        <button type="button" class="ghost" (click)="prevStep()">Prev</button>
        <button type="button" class="ghost" (click)="onReset()">Cancel</button>
        <button type="button" class="primary" [disabled]="!selectedFacilitator" (click)="nextStep()">Save</button>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="3">
      <div class="facility-pair summary">
        <div class="facility-card accent-red">
          <div class="label">Facility</div>
          <div class="name">{{ formatFacilityName(originFacility.name) }}</div>
          <div class="patient-id">
            Patient ID: <span>{{ originFacility.patientId }}</span>
          </div>
        </div>

        <div class="arrow-animation">
          <div class="arrow">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>

        <div class="facility-card accent-blue" *ngIf="selectedFacility">
          <div class="label">Facility</div>
          <div class="name">{{ formatFacilityName(selectedFacility.name) }}</div>
          <div class="patient-id">
            Patient ID: <span>{{ selectedFacility.patientId }}</span>
          </div>
        </div>
      </div>

      <div class="facilitator-summary" *ngIf="selectedFacilitator">
        <div class="label">Facilitator:</div>
        <div class="pill">{{ selectedFacilitator.email }}</div>
      </div>

      <div class="actions">
        <button type="button" class="primary" (click)="keepSelection()">Keep it</button>
        <button type="button" class="ghost" (click)="modifySelection()">Modify</button>
      </div>

      <p class="status-message" *ngIf="statusMessage">{{ statusMessage }}</p>
    </ng-container>
  </ng-container>
</div>

